import React from 'react';
import { Form, Input, Button, Select, message, Popover } from 'antd';
import { Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';

const { Option } = Select;

class HandleRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.token,
            roles: [
                        { role: "Administrator", roleId: 1 }, 
                        { role: "Archivio Riviste User", roleId: 2 },
                        { role: "Uomini e Comunicazione User", roleId: 3 },
                    ],
            username: null,
            name: null,
            surname: null, 
            email: null,
            selectedRole: null,
            password: null,
            passwordTwo: null,
            passwordCheck: false,
            usernameAlarm: false,
            nameAlarm: false,
            surnameAlarm: false,
            emailAlarm: false,   
            roleAlarm: false,
            passwordAlarm: false,
            passwordCheckAlarm: false,
            passShort: false,
            checkAt: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUserEmail = this.handleUserEmail.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handlePasswordCheck = this.handlePasswordCheck.bind(this);
        this.handleUsername = this.handleUsername.bind(this);        
        this.handleName = this.handleName.bind(this);
        this.handleSurname = this.handleSurname.bind(this);
        this.handlePasswordTwo = this.handlePasswordTwo.bind(this);
        this.handleRoles = this.handleRoles.bind(this);       
        this.registerUser = this.registerUser.bind(this);       
    }

    handleSubmit() {
        this.handlePasswordCheck(this.state.passwordTwo)
        if (this.state.username && this.state.name && this.state.surname && this.state.email && this.state.selectedRole && this.state.password && this.state.passwordCheck, !this.state.checkAt ) {
            this.setState({ usernameAlarm: false, nameAlarm: false, surnameAlarm: false, emailAlarm: false, roleAlarm: false, passwordAlarm: false, passwordCheckAlarm: false })
            this.registerUser()
        } else {
            if (!this.state.username) {
                this.setState({ usernameAlarm: true })
            }
            if (!this.state.name) {
                this.setState({ nameAlarm: true })
            }
            if (!this.state.surname) {
                this.setState({ surnameAlarm: true })
            }
            if (!this.state.email) {
                this.setState({ emailAlarm: true })
            }
            if (!this.state.selectedRole) {
                this.setState({ roleAlarm: true })
            }
            if (!this.state.password) {
                this.setState({ passwordAlarm: true })
            }
            if (!this.state.passwordCheck) {
                this.setState({ passwordCheckAlarm: true })
            }
        }
    }

    handleUsername(event) {
        this.setState({ username: event.target.value, usernameAlarm: false });
        if (event.target.value.length === 0) {
            this.setState({ username: null })
        }
    }

    handleName(event) {
        this.setState({ name: event.target.value, nameAlarm: false });
        if (event.target.value.length === 0) {
            this.setState({ name: null })
        }
    }

    handleSurname(event) {
        this.setState({ surname: event.target.value, surnameAlarm: false });
        if (event.target.value.length === 0) {
            this.setState({ surname: null })
        }
    }

    handleUserEmail(event) {
        this.setState({ email: event.target.value, emailAlarm: false, checkAt: false });

        if (event.target.value.length === 0) {
            this.setState({ email: null, checkAt: false })
        } else if (event.target.value.indexOf("@") == -1 || event.target.value.indexOf(".") == -1 || event.target.value.length < 6) {       
            this.setState({ email: null, checkAt: true })
        }
    }

    handleRoles(value) {
        this.setState({ selectedRole: value, roleAlarm: false })
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value, passwordAlarm: false, passShort: false,  });

        if (event.target.value.length < 5 && event.target.value.length > 0) {
            this.setState({ password: null, passShort: true })
        } else if (event.target.value.length === 0){
            this.setState({ password: null, passShort: false })
        }
    }

    handlePasswordTwo(event) {
        this.setState({ passwordTwo: event.target.value });

        if (event.target.value.length === 0) {
            this.setState({ passwordTwo: null })
        }
    }

    handlePasswordCheck() {
        if (this.state.password == this.state.passwordTwo) {
            this.setState({ passwordCheck: true, passwordCheckAlarm: false })
        } else {
            this.setState({ passwordCheck: false, passwordCheckAlarm: true})
        }
    }

    sendDataShowList = () => {
        this.props.parentShowList(true);
    }

    registerUser() {
        fetch(`${SERVER_URL + 'api/users'}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`,
            },
            body: JSON.stringify({
                'FirstName': this.state.name,
                'LastName': this.state.surname,
                'Username': this.state.username,
                'Email': this.state.email,
                'Password': this.state.password,
                'IsEnabled': true,
                'UserRoleId': this.state.selectedRole,
            })
        }).then(response => response.json())
            .then(res => {
                if (res.ok) {
                    message.success('User created successfully');
                    window.location.reload();
                } else {
                    message.warning("Warning, Username or Email already in use by another User, or Email doesn't exist");
                }
            })        
    }

    render() {

        let roleOption = this.state.roles.map((el, i) => {
            return <Option key={i} value={el.roleId}>{el.role}</Option>
        })

        let registerButton = this.state.username == null ||
            this.state.name == null ||
            this.state.surname == null ||
            this.state.email == null ||
            this.state.selectedRole == null ||
            this.state.password == null ||
            this.state.passwordTwo == null ?
            //se non tutti i campi sono compilati
            <Popover content="There is some missing data">
                <Button disabled style={{ boxShadow: '0px 0px 5px 2px #eeeeee' }}>
                    Register
                </Button>
            </Popover> :
            <Button onClick={this.handleSubmit} style={{ boxShadow: '0px 0px 5px 2px #eeeeee' }}>
                Register
            </Button>

        let maxChar = this.state.username != null ? this.state.username.length > 24 ? <p style={{ color: 'red', marginLeft:'15px' }}>Max 25 characters</p> : null : null

        return (
            <Row className="createUserRow">
                <Col sm="12">
                    <Form autoComplete="off" className="login-form registerForm" style={{ padding: '50px', background:'#fff' }}>                
                        <h3>Register a new User:</h3>
                        <div className="formBody">
                            <div style={{ width: '100%', marginBottom:'10px' }}>
                                <Form.Item style={{ height: '14px' }}>
                                    <div style={{ display: 'inline-flex', width: '100%' }}>
                                        <p>Username<span style={{ color: 'red' }}> *</span></p>
                                        <Input
                                            autoComplete="new-password"
                                            className={"border" + this.state.usernameAlarm}
                                            placeholder="Username"
                                            onChange={this.handleUsername}
                                            maxLength={25}
                                            style={{ width:'32%' }}
                                        />
                                        {maxChar}
                                    </div>
                                </Form.Item>
                            </div>                            
                            <div style={{ display:'inline-flex', width:'100%' }}>
                                <div style={{ width: '48%' }}>
                                    <Form.Item style={{ height: '32px', marginBottom: '10px',  }}>
                                        <div style={{ display: 'inline-flex', width: '100%' }}>
                                            <p>Name<span style={{ color: 'red' }}> *</span></p>
                                            <Input
                                                autoComplete="new-password"
                                                className={"border" + this.state.nameAlarm}
                                                placeholder="Name"
                                                onChange={this.handleName}
                                            />
                                        </div>
                                    </Form.Item>
                                </div>
                                <div style={{ width: '48%', marginLeft: '4%' }}>
                                    <Form.Item style={{ height: '32px', marginBottom: '10px' }}>
                                        <div style={{ display: 'inline-flex', width: '100%' }}>
                                            <p>Surname<span style={{ color: 'red' }}> *</span></p>
                                            <Input
                                                autoComplete="new-password"
                                                className={"border" + this.state.surnameAlarm}
                                                placeholder="Surname"
                                                onChange={this.handleSurname}
                                            />
                                        </div>
                                    </Form.Item>
                                </div>
                            </div>
                            <div style={{ display: 'inline-flex', width: '100%' }}>
                                <div style={{ width: '48%' }}>
                                    <Form.Item style={{ height: '32px', marginBottom: '10px' }}>
                                        <div style={{ display: 'inline-flex', width: '100%' }}>
                                            <p>Email<span style={{ color: 'red' }}> *</span></p>
                                            <Input
                                                autoComplete="new-password"
                                                className={"border" + this.state.emailAlarm}
                                                placeholder="Email"
                                                onChange={this.handleUserEmail}
                                            />
                                            <p className={"noMatchAlert" + this.state.checkAt} style={{ fontSize: '13px', top: '14px' }}>Please enter a valid email address</p>
                                        </div>
                                    </Form.Item>
                                </div>
                                <div style={{ width: '48%', marginLeft: '4%' }}>
                                    <Form.Item style={{ height: '32px', marginBottom: '10px' }}>
                                        <div style={{ display: 'inline-flex', width: '100%' }}>
                                            <p>Role<span style={{ color: 'red' }}> *</span></p>
                                            <Select
                                                className={"border" + this.state.roleAlarm}
                                                placeholder="Role"
                                                style={{ width: '100%', height: '32px', marginBottom: '10px' }}
                                                onChange={this.handleRoles}
                                            >
                                                {roleOption}
                                            </Select>
                                        </div>
                                    </Form.Item>
                                </div>                                
                            </div>
                            <div style={{ display: 'inline-flex', width: '100%' }}>
                                <div style={{ width: '48%' }}>                                    
                                    <Form.Item style={{ height: '32px', marginBottom: '10px' }}>
                                        <div style={{ display: 'inline-flex', width: '100%' }} >
                                            <p>Password<span style={{ color: 'red' }}> *</span></p>
                                            <Input.Password
                                                autoComplete="new-password"
                                                className={"border" + this.state.passwordAlarm + " border" + this.state.passwordCheckAlarm}
                                                placeholder="Password"
                                                onChange={this.handlePasswordChange}
                                            />
                                            <p className={"noMatchAlert" + this.state.passwordCheckAlarm}>Passwords don't match</p>
                                            <p className={"noMatchAlert" + this.state.passShort + " mt10"}>The Password is too short (min 5 characters)</p>
                                        </div>
                                    </Form.Item>                
                                </div>
                                <div style={{ width: '48%', marginLeft: '4%' }}>
                                    <Form.Item style={{ height: '32px', marginBottom: '10px' }}>
                                        <div style={{ display: 'inline-flex', width: '100%' }} >
                                            <p>Confirm Password <span style={{ color: 'red' }}> *</span></p>
                                            <Input.Password
                                                className={"border" + this.state.passwordCheckAlarm}
                                                autoComplete="new-password"
                                                placeholder="Confirm Password"
                                                onChange={this.handlePasswordTwo}
                                                onBlur={this.handlePasswordCheck}
                                            />
                                            <p className={"noMatchAlert" + this.state.passwordCheckAlarm}>Passwords don't match</p>
                                        </div>
                                    </Form.Item>
                                </div>    
                            </div>
                        </div>
                        <p style={{ color: 'red', margin:'10px 0px 0px', fontSize:'12px', textAlign:'right' }}>*Mandatory</p>
                        <Form.Item style={{ margin: '30px auto 0px', maxWidth: '200px' }}>
                            {registerButton}
                            <Button onClick={this.sendDataShowList} style={{ float: 'right', marginTop: '4px', boxShadow: '0px 0px 5px 2px #eeeeee' }}>
                                Cancel
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        )
    }


}

export default HandleRegistration;


// WEBPACK FOOTER //
// ./src/Users/HandleRegistration.js